module.exports = __webpack_public_path__ + "img/pay-refuse.ef605c20.png";